import React from "react";
import phoneImg from "./images/mobile1.jpg";
import { useGlobalContext } from "./context";
import { Text } from "../containers/Language";
import { Link } from "react-router-dom";
const Hero = () => {
  const { closeSubmenu } = useGlobalContext();
  return (
    <section className="hero" onMouseOver={closeSubmenu}>
      <div className="hero-center">
        <article className="hero-info">
          <h1 className="hero_info_h1">
            <Text tid="welcomeSection" />
          </h1>
          <p className="hero_info_h1">
            <Text tid="welcomeDis" />
          </p>
          <Link to="/Newregisterfile" className="get_started_btn">
            <Text tid="WelcomeStartSec" />
          </Link>
        </article>

        <article className="hero-images">
          <img src={phoneImg} className="phone-img" alt="phone" />
        </article>
        <form
          action="https://www.paypal.com/donate"
          method="post"
          target="_top"
        >
          <input type="hidden" name="hosted_button_id" value="GFJ4JVQY7TQD6" />
          <input
            type="image"
            src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
            border="0"
            name="submit"
            title="PayPal - The safer, easier way to pay online!"
            alt="Donate with PayPal button"
          />
          <img
            alt=""
            border="0"
            src="https://www.paypal.com/en_GR/i/scr/pixel.gif"
            width="1"
            height="1"
          />
        </form>
      </div>
    </section>
  );
};

export default Hero;
